import React from 'react';

// simple floating whatsapp button linking to your chat number
export default function WhatsAppButton() {
  const phone = '918287934973';
  const url = `https://wa.me/${phone}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 left-4 z-40 bg-green-500 text-white p-4 rounded-full shadow-lg transition-colors hover:bg-green-600 md:bottom-6 md:left-6"
      aria-label="Chat with us on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        className="w-6 h-6"
      >
        <path d="M20.52 3.48A11.78 11.78 0 0 0 12 0C5.372 0 0 5.372 0 12a11.9 11.9 0 0 0 1.66 6.01L0 24l5.99-1.57A11.9 11.9 0 0 0 12 24c6.628 0 12-5.372 12-12a11.78 11.78 0 0 0-3.48-8.52zM12 21.5a9.46 9.46 0 0 1-5.11-1.42l-.37-.22-3.56.93.95-3.48-.24-.36A9.46 9.46 0 0 1 2.5 12a9.5 9.5 0 0 1 16.49-6.73A9.5 9.5 0 0 1 21.5 12a9.46 9.46 0 0 1-1.5 5.12l-.22.37-.93 3.56 3.48-.95.36.24A9.46 9.46 0 0 1 12 21.5zm5.337-7.9c-.298-.15-1.76-.868-2.033-.967-.272-.1-.47-.149-.668.15-.198.299-.768.967-.942 1.166-.174.199-.348.223-.646.074-.298-.15-1.256-.463-2.39-1.48-.883-.786-1.48-1.755-1.652-2.053-.173-.298-.018-.459.13-.608.134-.133.298-.347.447-.52.15-.174.199-.298.299-.497.1-.198.05-.372-.025-.52-.075-.149-.668-1.612-.916-2.21-.242-.579-.487-.5-.668-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.199 2.095 3.2 5.075 4.487.71.306 1.262.489 1.693.626.712.226 1.36.194 1.873.118.572-.085 1.76-.719 2.007-1.413.248-.695.248-1.29.174-1.413-.074-.124-.27-.198-.568-.347z" />
      </svg>
    </a>
  );
}
